import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import CircularBuffer from "./CircularBuffer";
import LeastSquareSolver from "./LeastSquareSolver";
var VelocityTracker = /*#__PURE__*/ function() {
    "use strict";
    function VelocityTracker() {
        _class_call_check(this, VelocityTracker);
        _define_property(this, "assumePointerMoveStoppedMilliseconds", 40);
        _define_property(this, "historySize", 20);
        _define_property(this, "horizonMilliseconds", 300);
        _define_property(this, "minSampleSize", 3);
        _define_property(this, "samples", void 0);
        this.samples = new CircularBuffer(this.historySize);
    }
    _create_class(VelocityTracker, [
        {
            key: "add",
            value: function add(event) {
                this.samples.push(event);
            }
        },
        {
            key: "getVelocityEstimate",
            value: /// Returns an estimate of the velocity of the object being tracked by the
            /// tracker given the current information available to the tracker.
            ///
            /// Information is added using [addPosition].
            ///
            /// Returns null if there is no data on which to base an estimate.
            function getVelocityEstimate() {
                var x = [];
                var y = [];
                var w = [];
                var time = [];
                var sampleCount = 0;
                var index = this.samples.size - 1;
                var newestSample = this.samples.get(index);
                if (!newestSample) {
                    return null;
                }
                var previousSample = newestSample;
                // Starting with the most recent PointAtTime sample, iterate backwards while
                // the samples represent continuous motion.
                while(sampleCount < this.samples.size){
                    var sample = this.samples.get(index);
                    var age = newestSample.time - sample.time;
                    var delta = Math.abs(sample.time - previousSample.time);
                    previousSample = sample;
                    if (age > this.horizonMilliseconds || delta > this.assumePointerMoveStoppedMilliseconds) {
                        break;
                    }
                    x.push(sample.x);
                    y.push(sample.y);
                    w.push(1);
                    time.push(-age);
                    sampleCount++;
                    index--;
                }
                if (sampleCount >= this.minSampleSize) {
                    var xSolver = new LeastSquareSolver(time, x, w);
                    var xFit = xSolver.solve(2);
                    if (xFit !== null) {
                        var ySolver = new LeastSquareSolver(time, y, w);
                        var yFit = ySolver.solve(2);
                        if (yFit !== null) {
                            var xVelocity = xFit.coefficients[1] * 1000;
                            var yVelocity = yFit.coefficients[1] * 1000;
                            return [
                                xVelocity,
                                yVelocity
                            ];
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "getVelocity",
            value: function getVelocity() {
                var estimate = this.getVelocityEstimate();
                if (estimate !== null) {
                    return estimate;
                }
                return [
                    0,
                    0
                ];
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.samples.clear();
            }
        }
    ]);
    return VelocityTracker;
}();
export { VelocityTracker as default };
